<template>
    <div class="container">
        <div __class="airboard" style="z-index: 999999; position: relative;" v-if="$refs">
            <div class="panel__menuBar">
                <ui-FormSelect label="Mostrar:" v-model="refOnened" :options="Object.keys($refs)"></ui-FormSelect>
            </div>
        </div>

        <!-- Login  -->
        <ui-Airboard ref="Login" panel="login" :feedback="feedback" __classStyles="d-none">
            <template v-slot:body>
                <inline-svg class="logo" :src="getImage('mysair-logo.svg')"></inline-svg>
                <div class="welcome">Controlll de dispositivos MYSAir</div>

                <ui-FormInput label="Usuario" __:isError="true" __v-model="installation.name"></ui-FormInput>
                <ui-FormInput
                    label="Contraseña"
                    type="password"
                    classStyles="mt-3"
                    __v-model="installation.name"
                ></ui-FormInput>

                <a class="btn btn--simple my-3">Iniciar sesión</a>

                <a class="link" href="">¿Has olvidado la contraseña?</a>
                <hr />
                <a class="link mt-2" href="">Ir al registro</a>

                <div class="panel__feedback">
                    <div class="feedback__content" data-icoTarget="exclamation">
                        Su usuario o contraseña no son correctos
                    </div>
                    <div class="btn btn--outline mt-3">cerrar</div>
                </div>
            </template>
        </ui-Airboard>

        <!-- Panel de termostato -->
        <div ref="Panel de Termostato" class="row mt-4 d-none">
            <div class="col">
                <p>panel de termostato</p>
                <div style="height: 850px; position: relative;">
                    <ui-PanelThermostat
                        :show="true"
                        __:modeHeat="true"
                        __:outService="true"
                        :programming="true"
                        name="Mi lugar de estudio"
                        ubication="casa de la playa"
                        typeSpace="space-study"
                        temperaturaLabel="Temperatura"
                        :temperaturaValue="26.5"
                        humedadLabel="Humedad"
                        :humedadValue="76"
                        modeLabel="Modo calor"
                        modeIcoTarget="mode-heat"
                        outServiceLabel="fuera de servicio"
                    >
                        <template v-slot:menuBar>
                            <div class="icoButton" data-icoTarget="left"></div>
                            <div class="icoButton __sync" data-icoTarget="sync"></div>
                            <div class="icoButton __icoButton--active" data-icoTarget="favorites"></div>
                            <div class="icoButton" data-icoTarget="setUp"></div>
                        </template>

                        <template v-slot:body>
                            <ui-TempControlDevice
                                :vertical="true"
                                :min="18"
                                :max="28"
                                :real="realT"
                                :order.sync="orderT"
                            >
                            </ui-TempControlDevice>

                            <div class="blocks">
                                <div class="block">
                                    <ui-Switch :status.sync="status1"></ui-Switch>
                                    <p class="titleSection">Sistemas activos</p>
                                    <ui-IcoGroup
                                        valueIco="ventilation"
                                        name="Ventilación a velocidad 2"
                                        :actives="ventilationActive ? [ventilationActive] : []"
                                        :groups="ventilationGroups"
                                        @click="clickGroup"
                                        @itemClick="fanMode = $event"
                                    >
                                    </ui-IcoGroup>
                                    <ui-IcoGroup
                                        valueIco="radiatingFloor"
                                        name="Suelo radiante"
                                        :actives="[]"
                                        :groups="[]"
                                        @click="clickGroup"
                                        @itemClick="fanMode = $event"
                                    >
                                    </ui-IcoGroup>
                                </div>
                                <div class="block">
                                    <p class="titleSection">Temporizador y programación</p>
                                    <ui-IcoGroup
                                        valueIco="timer"
                                        name="3' para apagado"
                                        :actives="timerActive ? [timerActive] : []"
                                        :groups="timerGroups"
                                        @click="clickGroup"
                                        @itemClick="fanMode = $event"
                                    >
                                    </ui-IcoGroup>
                                    <ui-IcoGroup
                                        valueIco="clock"
                                        name="Programaciones"
                                        groupInfo="manual/auto"
                                        :actives="[]"
                                        :groups="[]"
                                        @click="clickGroup"
                                        @itemClick="fanMode = $event"
                                    >
                                    </ui-IcoGroup>
                                </div>
                            </div>
                        </template>

                        <template v-slot:bodyProgramming>
                            <ui-Programming>
                                <template v-slot:programmingOrder>
                                    <ui-IcoBtn :active="modeHeat" valueIco="mode-heat" />
                                    <ui-IcoBtn :active="modeHeat" classStyles="ms-1" valueIco="mode-cool" />
                                    <ui-IcoBtn :active="true" classStyles="ms-3" valueIco="ventilation"></ui-IcoBtn>
                                    <ui-IcoBtn :active="false" classStyles="ms-1" valueIco="radiatingFloor"></ui-IcoBtn>
                                    <ui-TempControlInstallation
                                        :active="true"
                                        :min="18"
                                        :max="28"
                                        :order.sync="orderT"
                                    ></ui-TempControlInstallation>
                                </template>
                                <template v-slot:programmingSwitch>
                                    <ui-Switch :status.sync="status1"></ui-Switch>
                                </template>
                            </ui-Programming>
                            <ui-Programming>
                                <template v-slot:programmingOrder>
                                    <ui-IcoBtn :active="modeHeat" valueIco="mode-heat" />
                                    <ui-IcoBtn :active="modeHeat" classStyles="ms-1" valueIco="mode-cool" />
                                    <ui-IcoBtn :active="true" classStyles="ms-3" valueIco="ventilation"></ui-IcoBtn>
                                    <ui-IcoBtn :active="false" classStyles="ms-1" valueIco="radiatingFloor"></ui-IcoBtn>
                                    <ui-TempControlInstallation
                                        :active="true"
                                        :min="18"
                                        :max="28"
                                        :order.sync="orderT"
                                    ></ui-TempControlInstallation>
                                </template>
                                <template v-slot:programmingSwitch>
                                    <ui-Switch :status.sync="status1"></ui-Switch>
                                </template>
                            </ui-Programming>
                        </template>
                    </ui-PanelThermostat>
                </div>
            </div>
        </div>

        <!-- Box de programación -->
        <div ref="Box de programacion" class="row mt-4 d-none" :class="{ modeHeat: modeHeat }">
            <div class="col">
                <p>programación</p>
                <ui-Programming>
                    <template v-slot:programmingOrder>
                        <ui-IcoBtn :active="modeHeat" valueIco="mode-heat" />
                        <ui-IcoBtn :active="modeHeat" classStyles="ms-1" valueIco="mode-cool" />
                        <ui-IcoBtn :active="true" classStyles="ms-3" valueIco="ventilation"></ui-IcoBtn>
                        <ui-IcoBtn :active="false" classStyles="ms-1" valueIco="radiatingFloor"></ui-IcoBtn>
                        <ui-TempControlInstallation
                            :active="true"
                            :min="18"
                            :max="28"
                            :order.sync="orderT"
                        ></ui-TempControlInstallation>
                    </template>
                    <template v-slot:programmingSwitch>
                        <ui-Switch :status.sync="status1"></ui-Switch>
                    </template>
                </ui-Programming>
            </div>
        </div>

        <!-- Menu vitaminado -->
        <div ref="Menu vitaminado" class="row mt-4 d-none" :class="{ modeHeat: modeHeat }">
            <div class="col">
                <p>menu vitaminado</p>
                <ui-RichMenu
                    name="Instalación de zonas"
                    icono="installation-zones"
                    __:navigation="true"
                    __:navigationStop="true"
                    :edition="true"
                    :select="true"
                    nameInstallation="Nombre de la instalación"
                >
                    <template v-slot:options>
                        <ui-RichMenuOption
                            name="Nombre de la opción 1"
                            icono="space-kitchen"
                            @click="llamadaok('click en option')"
                            @clickAction="llamadaok('click en icono de acción')"
                        ></ui-RichMenuOption>
                        <ui-RichMenuOption name="Nombre de la opción 2" icono="space-office"></ui-RichMenuOption>
                        <ui-RichMenuOption name="Nombre de la opción 3" icono="space-study"></ui-RichMenuOption>
                        <ui-RichMenuOption
                            name="Nombre de la opción 4"
                            icono="space-office"
                            :active="true"
                            :edition="true"
                        ></ui-RichMenuOption>
                        <ui-RichMenuOption name="Nombre de la opción 5" icono="space-livingRoom"></ui-RichMenuOption>
                        <!-- <ui-RichMenuOption name="Agregar un espacio" :add="true"></ui-RichMenuOption> -->
                        <ui-RichMenuOption name="Cerrar sesión" :logout="true"></ui-RichMenuOption>
                    </template>
                </ui-RichMenu>
            </div>
        </div>

        <!-- Instalación, propiedades y grupo de dispositivos -->
        <div ref="Instalación" class="row mt-4 d-none" :class="{ modeHeat: modeHeat }">
            <div class="col">
                <p>instalación, propiedades y grupo de dispositivos</p>
                <ui-Installation
                    __name="este es el nombre de la instalación"
                    __type="installation-switches"
                    :open="true"
                    :show.sync="installationShow"
                    __:hidden="true"
                    :outService="true"
                >
                    <template v-slot:installationProperties>
                        <div class="installationProperties installationProperties__zones">
                            <p class="titleSection">Modo de trabajo</p>
                            <div class="modes-wrap">
                                <ui-IcoBtn :sizeLg="true" :active="true" label="calor" valueIco="mode-heat"></ui-IcoBtn>
                                <ui-IcoBtn
                                    :sizeLg="true"
                                    label="frio"
                                    valueIco="mode-cool"
                                    classStyles="ms-2"
                                ></ui-IcoBtn>
                            </div>
                            <div class="tempControlInstallation-wrap">
                                <ui-TempControlInstallation
                                    :active.sync="tempControlInstallationActive"
                                    :min="18"
                                    :max="28"
                                    :order.sync="orderT"
                                    buttonText="unificar temperatura"
                                ></ui-TempControlInstallation>
                            </div>
                            <div class="switch-wrap">
                                <ui-Switch :status.sync="status1" :disabled="disabled" :standby="standby"></ui-Switch>
                            </div>
                            <div class="installationProperties__outService"><i>fuera de servicio</i></div>
                        </div>
                    </template>
                    <template v-slot:device>
                        <ui-DeviceThermostat
                            __name="Nombre del espacio (en su defecto: Termostato)"
                            __spaceType="space-livingRoom"
                            __:min="18"
                            __:max="28"
                            :real="realT"
                            :order="orderT"
                            :status.sync="status1"
                            :outService="true"
                            @click="llamadaok('ir al control completo del dispositivo')"
                        >
                            <template v-slot:properties>
                                <ui-Ico :disabled="true" valueIco="ventilation"></ui-Ico>
                                <ui-Ico :disabled="false" valueIco="radiatingFloor"></ui-Ico>
                            </template>
                        </ui-DeviceThermostat>
                    </template>
                </ui-Installation>
            </div>
        </div>

        <!-- Box de dispositivo en instalación/favoritos (termostato) -->
        <div ref="Box de dispositivo" class="row mt-4 d-none" :class="{ modeHeat: modeHeat }">
            <div class="col">
                <p>box de dispositivo en instalación/favoritos (termostato)</p>
                <ui-DeviceThermostat
                    __name="Nombre del espacio (en su defecto: Termostato)"
                    __spaceType="space-livingRoom"
                    __:min="18"
                    __:max="28"
                    :real="realT"
                    :order="orderT"
                    :status.sync="status1"
                    :outService="true"
                    @click="llamadaok('ir al control completo del dispositivo')"
                >
                    <template v-slot:properties>
                        <ui-Ico :disabled="true" valueIco="ventilation"></ui-Ico>
                        <ui-Ico :disabled="false" valueIco="radiatingFloor"></ui-Ico>
                    </template>
                </ui-DeviceThermostat>
            </div>
        </div>

        <!-- Box ubicación -->
        <div ref="Box ubicacion" class="row mt-4 d-none">
            <div class="col">
                <p>Box ubicación</p>
                <ui-Ubication
                    location="San Pedro de Alcantara"
                    weather="soleado"
                    :temperature="22.5"
                    :min="16"
                    :max="23"
                    @addInstallation="llamadaok('agregar instalación')"
                    @click="llamadaok('ir a las instalaciones de la ubicación')"
                >
                    <template v-slot:installations>
                        <ui-Ico label="temperatura zonas" valueIco="installation-zones"></ui-Ico>
                        <ui-Ico label="reles" valueIco="installation-switches"></ui-Ico>
                    </template>
                </ui-Ubication>
            </div>
        </div>

        <!-- Consigna de temperatura -->
        <div ref="Consigna de temperatura" class="row mt-4 d-none" :class="{ modeHeat: modeHeat }">
            <div class="col">
                <div>Consigna de temperatura</div>
                <div style="height: 300px">
                    <ui-TempControlDevice
                        :vertical="true"
                        :minMaxHidden="false"
                        :min="18"
                        :max="28"
                        :real="realT"
                        :order.sync="orderT"
                    ></ui-TempControlDevice>
                </div>
            </div>
        </div>

        <!-- Botón ON/OFF -->
        <div ref="Botón ON/OFF" class="row mt-4 d-none" :class="{ modeHeat: modeHeat }">
            <div class="col">
                <p>Botón de ON/OFF</p>
                <div class="d-flex align-items-end justify-content-between">
                    <ui-Switch :status.sync="status1" :disabled="disabled" :standby="standby"></ui-Switch>
                    <ui-Switch :status.sync="status2" :disabled="disabled" :standby="standby"></ui-Switch>
                </div>
            </div>
        </div>

        <!-- Iconos estilos -->
        <div ref="Iconos estilos" class="row mt-4 d-none" :class="{ modeHeat: modeHeat }">
            <div class="col-12">
                <p>Iconos estilos</p>
                <div class="d-flex align-items-end justify-content-between">
                    <ui-Ico label="info" valueIco="installation-zones"></ui-Ico>
                    <ui-IcoBtn
                        :active="icoActive1"
                        label="button"
                        valueIco="installation-zones"
                        @click="(icoActive1 = !icoActive1), llamadaok('pushButton')"
                    ></ui-IcoBtn>
                    <ui-IcoBtn
                        :active="icoActive2"
                        label="button active"
                        valueIco="installation-zones"
                        @click="(icoActive2 = !icoActive2), llamadaok('button normal')"
                    ></ui-IcoBtn>
                    <ui-Ico :disabled="true" label="desactivado" valueIco="installation-zones"></ui-Ico>
                    <ui-IcoBtn
                        :sizeLg="true"
                        :active="icoActive1"
                        label="grande con texto"
                        valueText="120"
                        @click="llamadaok()"
                    ></ui-IcoBtn>
                </div>
            </div>
            <div class="col-12">
                <p>Icono con selector</p>
                <ui-IcoGroup
                    valueIco="ventilation"
                    name="Velocidad de funcionamiento"
                    :actives="fanMode ? [fanMode] : []"
                    :groups="groups"
                    @click="clickGroup"
                    @itemClick="fanMode = $event"
                ></ui-IcoGroup>
            </div>
        </div>
    </div>
</template>

<script>
    import ui_Ico from '../components_ui/ui-Ico.vue';
    import ui_IcoBtn from '../components_ui/ui-IcoBtn.vue';
    import ui_IcoGroup from '../components_ui/ui-IcoGroup.vue';
    import ui_Switch from '../components_ui/ui-Switch.vue';
    import ui_TempControlDevice from '../components_ui/ui-TempControlDevice.vue';
    import ui_TempControlInstallation from '../components_ui/ui-TempControlInstallation.vue';
    import ui_DeviceThermostat from '../components_ui/ui-DeviceThermostat.vue';
    import ui_Installation from '../components_ui/ui-Installation.vue';
    import ui_Ubication from '../components_ui/ui-Ubication.vue';
    import ui_RichMenu from '../components_ui/ui-RichMenu.vue';
    import ui_RichMenuOption from '../components_ui/ui-RichMenuOption.vue';
    import ui_Programming from '../components_ui/ui-Programming.vue';
    import ui_PanelThermostat from '../components_ui/ui-PanelThermostat.vue';
    import ui_FormInput from '../components_ui/ui-FormInput.vue';

    export default {
        components: {
            ui_Ico,
            ui_IcoBtn,
            ui_IcoGroup,
            ui_Switch,
            ui_TempControlDevice,
            ui_TempControlInstallation,
            ui_DeviceThermostat,
            ui_Installation,
            ui_Ubication,
            ui_RichMenu,
            ui_RichMenuOption,
            ui_Programming,
            ui_PanelThermostat,
            ui_FormInput,
        },
        name: 'drs-components',
        data: function() {
            return {
                refOnened: '',
                status1: true,
                status2: false,
                disabled: false,
                standby: false,

                icoActive1: false,
                icoActive2: true,

                tempControlInstallationActive: false,

                realT: 17,
                orderT: 23.5,

                modeHeat: false,

                installationShow: true,

                fanMode: null,
                groups: [
                    { key: 'auto', values: ['T', 'C'] },
                    { key: 'manual', values: ['1', '2', '3'] },
                ],

                ventilationActive: null,
                ventilationGroups: [
                    { key: '', values: ['A'] },
                    { key: 'manual', values: ['1', '2', '3'] },
                ],
                timerActive: null,
                timerGroups: [{ key: 'tiempo', values: ['30', '60', '90', '120'] }],

                feedback: false,
            };
        },
        mounted() {
            this.$forceUpdate();

            //nextTick para usar despues del renderizado equivalente a un setTomeout de 0
            this.$nextTick(() => {
                if (Object.keys(this.$refs)[sessionStorage.getItem('refOnened')])
                    this.refOnened = sessionStorage.getItem('refOnened');
                else this.refOnened = '0';
            });
        },
        methods: {
            showRef: function(ref) {
                this.refOnened = ref;
                dd('Click: ' + ref);
            },

            llamadaok: function(info) {
                dd('Click ok: ' + info);
            },

            clickGroup: function() {
                if (this.fanMode != null) this.fanMode = null;
                else this.fanMode = { group: 'auto', value: 'C' };
            },
        },
        computed: {},
        watch: {
            refOnened: {
                immediate: false,
                handler(val) {
                    sessionStorage.setItem('refOnened', val);
                    Object.keys(this.$refs).forEach((element) => {
                        let elementRef = this.$refs[element];
                        let elemntHTML = elementRef.$el ? elementRef.$el : elementRef;
                        elemntHTML.classList.add('d-none');
                    });

                    let element = Object.keys(this.$refs)[val];
                    let elementRef = this.$refs[element];
                    if (elementRef) {
                        let elemntHTML = elementRef.$el ? elementRef.$el : elementRef;
                        elemntHTML.classList.remove('d-none');
                    }
                },
            },
            // status: {
            //     immediate: true,
            //     handler(val) {
            //         this.statusData = val;
            //     },
            // },
        },
    };
</script>
